var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _circle, _circle2, _circle3, _rect2, _rect3, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendEmailPopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 165,
    viewBox: "0 0 231 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_607_1065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5.23528C5 3.44848 6.44849 2 8.23529 2H206.882C208.669 2 210.118 3.44849 210.118 5.23529V152.603C210.118 154.39 208.669 155.838 206.882 155.838H8.2353C6.44849 155.838 5 154.39 5 152.603V5.23528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61765 5.23528C6.61765 4.34189 7.34189 3.61765 8.23529 3.61765H206.882C207.776 3.61765 208.5 4.3419 208.5 5.23529V152.603C208.5 153.496 207.776 154.221 206.882 154.221H8.2353C7.3419 154.221 6.61765 153.496 6.61765 152.603V5.23528Z",
    stroke: "#0169EE",
    strokeWidth: 3.23529
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3672 100.677H193.455V105.53H20.3672V100.677Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5586 56.1914H140.073V61.0443H74.5586V56.1914Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1758 127.367H123.088V132.22H21.1758V127.367Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1758 137.883H183.749V142.736H21.1758V137.883Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5586 83.6914H125.514V88.5443H74.5586V83.6914Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1758 113.617H188.602V118.47H21.1758V113.617Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5586 69.9414H98.0145V74.7943H74.5586V69.9414Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.102 69.9414H129.557V74.7943H106.102V69.9414Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5586 42.4414H103.676V47.2943H74.5586V42.4414Z",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.148 42.4414H139.266V47.2943H110.148V42.4414Z",
    fill: "#E0E0E0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.23438,
    y: 5.23535,
    width: 198.971,
    height: 25.0735,
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.55,
    cy: 17.7725,
    r: 3.63971,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.683,
    cy: 17.7725,
    r: 3.63971,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.815,
    cy: 17.7725,
    r: 3.63971,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3242,
    y: 39.2061,
    width: 46.1029,
    height: 49.3382,
    rx: 3.23529,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147.352,
    y: 39.2061,
    width: 46.1029,
    height: 49.3382,
    rx: 3.23529,
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.341 147.734L133.974 122.899C132.77 121.558 131.135 120.805 129.43 120.805C127.725 120.805 126.09 121.558 124.885 122.899C122.372 125.69 122.372 130.199 124.885 132.99L151.829 162.907C154.343 165.698 158.404 165.698 160.918 162.907L229.115 87.1848C231.628 84.3935 231.628 79.8846 229.115 77.0933C227.91 75.7532 226.275 75 224.57 75C222.865 75 221.23 75.7532 220.026 77.0933L156.341 147.734Z",
    fill: "#79B330"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_607_1065",
    x: 0.147059,
    y: 0.382353,
    width: 214.823,
    height: 163.544,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.23529
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42647
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_607_1065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_607_1065",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmailPopup);
export default __webpack_public_path__ + "static/media/sendEmailPopup.fd76817c8d83397eac15302ca4de4fd1.svg";
export { ForwardRef as ReactComponent };